import React, { ReactElement } from 'react';
import {
  Link,
  SortLink, Table, Tbody, Td, Th, Thead, Tr,
} from 'idsk-react-components';
import UlohyOrganizacieListPage from '../../../../../model/legislativnyMaterial/UlohyOrganizacieListPage';
import routes from '../../../../../routing/routes';
import './ulohyOrganizacieList.scss';

interface Props {
  ulohyOrganizacie: UlohyOrganizacieListPage
}

const UlohyOrganizacieList = ({ ulohyOrganizacie }: Props): ReactElement => (
  <div className="ulohy-organizacie-list">
    <Table>
      <Thead>
        <Tr>
          <Th className="th-meno">
            <SortLink
              propertyName="meno"
              defaultDirection="asc"
              directionOfDefaultSort="asc"
              linkColor="black"
              doubleArrows
            >
              Meno
            </SortLink>
          </Th>
          <Th width="20%" className="th-pocet-uloh">
            <SortLink propertyName="pocetUloh" linkColor="black" doubleArrows>
              Počet úloh
            </SortLink>
          </Th>
          <Th width="20%" className="th-actions" />
        </Tr>
      </Thead>
      <Tbody>
        {ulohyOrganizacie.ulohyOrganizacie.map((ulohy) => (
          <Tr key={ulohy.subject.uuid}>
            <Td>{ulohy.subject.nazov}</Td>
            <Td>{ulohy.pocetUloh}</Td>
            <Td>
              <Link
                className="nazov-link"
                to={routes.ulohyOrganizacie.detail.withParams(ulohy.subject.uuid)}
              >Zobraziť úlohy
              </Link>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </div>
);

export default UlohyOrganizacieList;
